import { LicenseInfo } from "@mui/x-license-pro";

export const licenseKey =
  "cb68971bf5cd14404d3ce517376fdc9dTz0xMTg4MTYsRT0xNzg4OTk4Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=";

export const setupMuiLicense = () => {
  LicenseInfo.setLicenseKey(licenseKey);
};
